import classnames from "classnames";
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import ArticleItem from "./article-item/ArticleItem";
import styles from "./articles.module.scss";
import styleArticleLandingPage from "./landingPage.module.scss";
import OBDCategoryMakeModel from "./OBDCategoryMakeModel";
const FeaturedProducts = dynamic(() => import(/* webpackChunkName: "featured-products" */ "component/featured-products/featured-products.component"));

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      // articleTitle: PropTypes.string.isRequired,
      sections: PropTypes.array.isRequired,
    }),
  ).isRequired,
  imgSrc: PropTypes.string.isRequired,
  className: PropTypes.string,
};

const defaultProps = {
  className: "",
};

export default function Articles({
  items,
  imgSrc,
  className,
  useVizSensor,
  makeModelTiers,
  pageDetails,
  greyBackgroundInArticle = false,
}: any) {
  return (
    <div className={`${className} articles`}>
      {items.map((article: any, iArticle: any) => (

        <div
          className={classnames({
            [styles.article]: true,
            [styles.grey_background]: greyBackgroundInArticle,
          })}
          key={iArticle}
        >

          { article.articleTitle && <h2 className={styles.article_title} id={article.articleTitle}>{article.articleTitle}</h2>}
          {article.sections.map((section: any, sectionIndex: any) => {
            // hot fix of OBD pages.
            if (section?.title?.indexOf("Vehicles Frequently Showing") === 0 && makeModelTiers) {
              return <div className="p-t-20"><OBDCategoryMakeModel {...{ makeModelTiers, pageDetails }} /></div>;
            }
            if (useVizSensor === false) {
              return <ArticleItem key={sectionIndex} {...section} imgSrc={imgSrc} useVizSensor={false} />;
            }
            return (
              <ArticleItem key={sectionIndex} {...section} imgSrc={imgSrc} useVizSensor={sectionIndex !== 0} />
            );
          })}
          {
            article.featuredSection && article.featuredSection.featuredLinks.length !== 0 && (
              <div className={styleArticleLandingPage.featuredSection}>
                <span className={styleArticleLandingPage.featured_section_heading}>
                  <strong>{article.featuredSection.featuredSectionTitle}</strong>
                </span>
                <FeaturedProducts
                  products={article.featuredSection.featuredLinks}
                />
              </div>
            )
          }

        </div>
      ))}
    </div>
  );
}

Articles.propTypes = propTypes;
Articles.defaultProps = defaultProps;
